import React from 'react';
import PropTypes from 'prop-types';

const NoCouples = ({ color = '#224251', background = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M6.976 14.296v1.998l-3.565 1.294A2.159 2.159 0 0 0 2 19.632v1.366h13.572v-1.366a2.16 2.16 0 0 0-1.411-2.044l-3.565-1.294v-2.113"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M12.268 10.507c0 2.398-1.6 4.342-3.572 4.342-1.973 0-3.571-1.944-3.571-4.342 0-2.398 1.598-4.34 3.571-4.34 1.972 0 3.572 1.942 3.572 4.34Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M12.24 10.116c-.12.015-.219.006-.339.03-1.217.237-1.998-.21-2.668-1.397-.402.78-1.657 1.396-2.69 1.396-.507 0-.944-.105-1.381-.337"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.861 20.998H21v-1.365a2.16 2.16 0 0 0-1.41-2.044l-3.566-1.294v-2.114"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.125 6.167c1.972 0 3.571 1.943 3.571 4.34 0 2.398-1.599 4.342-3.571 4.342"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.668 10.116c-.12.015-.218.006-.338.03-1.218.237-1.998-.21-2.669-1.397"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="m12.292 3.742-.168-.247c-.193-.287-.479-.495-.822-.495-.547 0-.99.497-.99 1.113 0 .23.062.443.168.619.178.3 1.812 2.226 1.812 2.226m0-3.216s0 .248.167-.247c.11-.328.48-.495.822-.495.548 0 .99.497.99 1.113 0 .23-.062.443-.167.619-.178.3-1.812 2.226-1.812 2.226"
    />
    <path fill={color} d="M12.45 3.53h.238v.238h-.238z" />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.373}
      fill={color}
      stroke={background}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.373)"
    />
  </svg>
);

NoCouples.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string
};

export default NoCouples;
